<template>
  <v-col>
    <v-row style="max-height: 58px">
      <v-img
        contain
        :src="require('@/assets/logo.png')"
        max-height="58"
        class="ma-4"
      ></v-img>
    </v-row>
    <v-row justify="center"
      ><v-progress-circular indeterminate color="primary"></v-progress-circular
    ></v-row>
    <v-row justify="center" class="ma-4">
      <p>Please wait while we take you to the right place...</p>
    </v-row>
    <v-row justify="center">
      <p v-if="timer != -1">Redirecting in {{ timer }}...</p>
    </v-row>
  </v-col>
</template>

<script>
import { auth } from '@/firebaseConfig'
import { mapActions } from 'vuex'

export default {
  data: () => ({
    timer: -1
  }),
  computed: {
    mode() {
      return this.$route.query.mode
    },
    oobCode() {
      return this.$route.query.oobCode
    },
    continueUrl() {
      return this.$route.query.continueUrl
    }
  },
  mounted() {
    switch (this.mode) {
    case 'verifyEmail':
      this.handleVerifyEmail()
      break
    case 'resetPassword':
      this.handleResetPassword()
      break
    case 'recoverEmail':
      this.goHome()
      break
    case 'signIn':
      this.emailSignIn()
      break
    default:
      this.goHome()
      break
    }
  },
  methods: {
    ...mapActions(['showError', 'showSuccess']),
    async handleVerifyEmail() {
      try {
        await auth.applyActionCode(this.oobCode)
        await auth.currentUser.reload()
        await auth.currentUser.getIdToken(true)
        this.showSuccess('Email verified')
        if (this.continueUrl) {
          window.location.href = this.continueUrl
        } else {
          this.$router.replace({ name: 'register' })
        }
      } catch (error) {
        this.showError(error.message)
        this.goHome()
      }
    },
    emailSignIn() {
      this.$router.replace({ name: 'signin-email', query: this.$route.query })
    },
    async handleResetPassword() {
      try {
        this.$router.replace({
          name: 'new-password',
          params: { code: this.oobCode }
        })
      } catch (error) {
        this.showError(error.message)
        this.goHome()
      }
    },
    goHome() {
      this.timer = 3
      this.goHomeTimer()
    },
    goHomeTimer() {
      if (this.timer > 0) {
        this.timer -= 1
        setTimeout(() => {
          this.goHomeTimer()
        }, 1000)
      } else {
        this.$router.replace({ name: 'home' })
      }
    }
  }
}
</script>

<style lang="sass" scoped>
p
 @include body_dark
 color: #595959
</style>
